var _circle, _circle2, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextNavigator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 69,
    stroke: "white",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49956,
    cy: 7.49956,
    r: 7.49956,
    transform: "matrix(-1 0 0 1 78.499 63)",
    fill: "white",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.744 70.4996C133.744 105.428 105.428 133.744 70.4996 133.744C35.5708 133.744 7.25537 105.428 7.25537 70.4996C7.25537 35.5708 35.5708 7.25537 70.4996 7.25537C105.428 7.25537 133.744 35.5708 133.744 70.4996ZM53.7056 70.4996C53.7056 79.7746 61.2245 87.2935 70.4996 87.2935C79.7746 87.2935 87.2935 79.7746 87.2935 70.4996C87.2935 61.2245 79.7746 53.7056 70.4996 53.7056C61.2245 53.7056 53.7056 61.2245 53.7056 70.4996Z",
    fill: "#222222",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4996 120.244C70.4996 127.7 76.6107 133.888 83.8973 132.308C87.5839 131.509 91.2003 130.38 94.7021 128.93C102.375 125.751 109.347 121.093 115.22 115.22C121.093 109.347 125.751 102.375 128.93 94.7021C132.108 87.0289 133.744 78.8049 133.744 70.4996C133.744 62.1942 132.108 53.9702 128.93 46.2971C125.751 38.6239 121.093 31.6519 115.22 25.7792C109.347 19.9064 102.375 15.2479 94.7021 12.0695C91.2003 10.6191 87.5839 9.48987 83.8973 8.69077C76.6107 7.11131 70.4996 13.2995 70.4996 20.7554L70.4996 47.1107C70.4996 50.753 73.5613 53.5902 76.9263 54.984V54.984C78.9638 55.828 80.8152 57.065 82.3747 58.6245C83.9341 60.1839 85.1711 62.0353 86.0151 64.0728C86.8591 66.1103 87.2935 68.2941 87.2935 70.4996C87.2935 72.705 86.8591 74.8888 86.0151 76.9263C85.1711 78.9638 83.9341 80.8152 82.3747 82.3747C80.8152 83.9341 78.9638 85.1711 76.9263 86.0151V86.0151C73.5613 87.409 70.4996 90.2461 70.4996 93.8884L70.4996 120.244Z",
    fill: "white",
    fillOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1249_3989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.854 70.3536C114.049 70.1583 114.049 69.8417 113.854 69.6464L110.672 66.4645C110.476 66.2692 110.16 66.2692 109.964 66.4645C109.769 66.6597 109.769 66.9763 109.964 67.1716L112.793 70L109.964 72.8284C109.769 73.0237 109.769 73.3403 109.964 73.5355C110.16 73.7308 110.476 73.7308 110.672 73.5355L113.854 70.3536ZM100.5 70.5H113.5V69.5H100.5V70.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1249_3989",
    x: 100.5,
    y: 66.3179,
    width: 13.5,
    height: 7.36426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1249_3989"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextNavigator);
export default __webpack_public_path__ + "static/media/nextNavigator.25d3e683e5195daa1cdd0d6b0549f144.svg";
export { ForwardRef as ReactComponent };